module.exports = __webpack_public_path__ + "static/media/HBI-HBN.8053cd0c.pdf";